import React from "react";

const footerData = {
  menus: [
    {
      id: "sand",
      title: "Sand",
      items: [
        { name: "Nadeshwar Sand", link: "" },
        { name: "Gujrat Sand", link: "" },
        { name: "Brown Silica Sand", link: "" },
        { name: "Bhusa Sand", link: "" },
        { name: "Quartz Sand", link: "" },
        { name: "Metal (Khadi)", link: "" },
        { name: "Crush Sand", link: "" },
      ],
    },
    {
      id: "cement",
      title: "Cement",
      items: [
        { name: "White Cement", link: "" },
        { name: "PCC Cement", link: "" },
        { name: "Plus Cement", link: "" },
        { name: "OPC 53 Grade Cement", link: "" },
      ],
    },
    {
      id: "brick",
      title: "Bricks",
      items: [
        { name: "Red Brick", link: "" },
        { name: "Cement Block", link: "" },
      ],
    },
    {
      "id": "water-proofing",
      "title": "Water Proofing",
      "items": [
        { "name": "Dr. Fixit", "link": "" },
        { "name": "Abro", "link": "" },
        { "name": "Berger", "link": "" },
        { "name": "Trubuild", "link": "" },
        { "name": "MYK Arment", "link": "" },
        { "name": "Saint Gobain India LTD.", "link": "" },
        { "name": "Redwop Chemicals", "link": "" },
        { "name": "Weber", "link": "" }
      ]
    },
    {
      "id": "marbles",
      "title": "Marbles",
      "items": [
        { "name": "Makrana", "link": "" },
        { "name": "Banswara White", "link": "" },
        { "name": "Albeta", "link": "" },
        { "name": "Carrara White", "link": "" },
        { "name": "Onyx", "link": "" },
        { "name": "Indian Statuario", "link": "" },
        { "name": "Cappuccino", "link": "" },
        { "name": "Fantasy", "link": "" }
      ]
    },
    {
      "id": "granites",
      "title": "Granites",
      "items": [
        { "name": "Alaska White", "link": "" },
        { "name": "Black Pearl", "link": "" },
        { "name": "Colonial White", "link": "" },
        { "name": "Moon White", "link": "" },
        { "name": "Galaxy Black", "link": "" },
        { "name": "Tan Brown", "link": "" },
        { "name": "Alaska Gold", "link": "" },
        { "name": "Imperial Red", "link": "" }
      ]
    }
  ],
  socialMedia: [
    {
      name: "Facebook",
      icon: "/assets/Images/facebook.svg",
      link: "",
      hoverColor: "hover:bg-blue-500",
    },
    {
      name: "Instagram",
      icon: "/assets/Images/instagram.svg",
      link: "",
      hoverColor: "hover:bg-rose-500",
    },
    {
      name: "LinkedIn",
      icon: "/assets/Images/linkedin.svg",
      link: "",
      hoverColor: "hover:bg-blue-500",
    },
    {
      name: "X-Twitter",
      icon: "/assets/Images/x.svg",
      link: "",
      hoverColor: "hover:bg-blue-500",
    },
    
  ],
};


const Footer = () => {
  const { menus, socialMedia } = footerData;

  return (
    <footer className="bg-yellow-200 p-4">
      <div className="container mx-auto px-4 lg:flex lg:justify-between">
        {menus.map((menu) => (
          <div key={menu.id} id={menu.id} className="mb-6 lg:mb-0">
            <h3 className="font-bold text-lg mb-2">{menu.title}</h3>
            <ul className="space-y-1">
              {menu.items.map((item, index) => (
                <li key={index}>
                  <a href={item.link} className="hover:text-yellow-600">
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="container mx-auto p-4">
        <div className="flex justify-center space-x-4">
          {socialMedia.map((media, index) => (
            <a key={index} href={media.link} aria-label={media.name}>
              <img
                src={media.icon}
                alt={media.name}
                className={`h-6 rounded-full ${media.hoverColor}`}
              />
            </a>
          ))}
        </div>
      </div>
      
      <div className="text-center p-2">
        <p className="text-gray-800">
           
          <a href="https://my-project-ashy-rho.vercel.app/" target="_blank" rel="noopener noreferrer">
          © 2024 Copyright. Yogesh Gupta All rights reserved.
           </a>
        </p>
      </div>
    </footer>
  );
};



export default Footer;
